/*
 * (C) 2026 BeyondDemise, All Rights Reserved.
 *
 * BaNotAuthorized — dead-end screen shown when an authenticated user lacks the
 * admin group. The only action is log out, which emits `ba-logout`.
 */

import { LitElement, html, type TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';

export const BA_LOGOUT_EVENT = 'ba-logout';

@customElement('ba-not-authorized')
export class BaNotAuthorized extends LitElement {
  override createRenderRoot(): HTMLElement {
    return this;
  }

  override render(): TemplateResult {
    return html`
      <div class="ba-login-shell">
        <wa-card class="ba-login-card" appearance="accent">
          <div slot="header"><strong>Access denied</strong></div>
          <wa-callout variant="warning">
            <wa-icon slot="icon" name="triangle-exclamation"></wa-icon>
            Your account is not authorized for the admin console.
          </wa-callout>
          <wa-button
            variant="neutral"
            data-testid="logout"
            @click=${this.onLogout}
          >
            Log out
          </wa-button>
        </wa-card>
      </div>
    `;
  }

  private onLogout(): void {
    this.dispatchEvent(
      new CustomEvent(BA_LOGOUT_EVENT, { bubbles: true, composed: true })
    );
  }
}
